var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 92,
    viewBox: "0 0 83 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0664 65.5578L15.5368 63.9855C11.9464 60.2949 5.36296 61.5685 2.98643 66.2085C1.8707 68.3909 1.61897 71.5418 3.6563 75.5631C5.61896 79.4351 9.70214 84.0729 17.0664 89.1247C24.4306 84.0729 28.5117 79.4351 30.4765 75.5631C32.5138 71.5396 32.2642 68.3909 31.1463 66.2085C28.7698 61.5685 22.1864 60.2927 18.596 63.9834L17.0664 65.5578ZM17.0664 91.6953C-15.6439 70.0805 6.99495 53.2101 16.6909 62.1338C16.8189 62.2511 16.9448 62.3727 17.0664 62.4986C17.1867 62.3729 17.312 62.2519 17.4418 62.1359C27.1357 53.2058 49.7767 70.0783 17.0664 91.6953Z",
    fill: "url(#paint0_linear_6326_51518)",
    className: "item1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7812 57.8625L28.2516 56.2902C24.6612 52.5996 18.0778 53.8732 15.7013 58.5131C14.5855 60.6955 14.3338 63.8465 16.3711 67.8678C18.3338 71.7398 22.417 76.3776 29.7812 81.4293C37.1455 76.3776 41.2265 71.7398 43.1913 67.8678C45.2286 63.8443 44.979 60.6955 43.8612 58.5131C41.4846 53.8732 34.9012 52.5974 31.3108 56.2881L29.7812 57.8625ZM29.7812 84C-2.92906 62.3851 19.7098 45.5148 29.4058 54.4385C29.5338 54.5558 29.6596 54.6774 29.7812 54.8033C29.9016 54.6775 30.0268 54.5566 30.1567 54.4406C39.8505 45.5105 62.4915 62.383 29.7812 84Z",
    fill: "url(#paint1_linear_6326_51518)",
    className: "item2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7812 42.8625L45.2516 41.2902C41.6612 37.5996 35.0778 38.8732 32.7013 43.5131C31.5855 45.6955 31.3338 48.8465 33.3711 52.8678C35.3338 56.7398 39.417 61.3776 46.7812 66.4293C54.1455 61.3776 58.2265 56.7398 60.1913 52.8678C62.2286 48.8443 61.979 45.6955 60.8612 43.5131C58.4846 38.8732 51.9012 37.5974 48.3108 41.2881L46.7812 42.8625ZM46.7812 69C14.0709 47.3851 36.7098 30.5148 46.4058 39.4385C46.5338 39.5558 46.6596 39.6774 46.7812 39.8033C46.9016 39.6775 47.0268 39.5566 47.1567 39.4406C56.8505 30.5105 79.4915 47.383 46.7812 69Z",
    fill: "url(#paint2_linear_6326_51518)",
    className: "item3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7812 5.86248L64.2516 4.29022C60.6612 0.599568 54.0778 1.87316 51.7013 6.51315C50.5855 8.69554 50.3338 11.8465 52.3711 15.8678C54.3338 19.7398 58.417 24.3776 65.7812 29.4293C73.1455 24.3776 77.2265 19.7398 79.1913 15.8678C81.2286 11.8443 80.979 8.69554 79.8612 6.51315C77.4846 1.87316 70.9012 0.597435 67.3108 4.28809L65.7812 5.86248ZM65.7812 32C33.0709 10.3851 55.7098 -6.48521 65.4058 2.4385C65.5338 2.55583 65.6596 2.67743 65.7812 2.80329C65.9016 2.67754 66.0268 2.55656 66.1567 2.44063C75.8505 -6.48948 98.4915 10.383 65.7812 32Z",
    fill: "url(#paint3_linear_6326_51518)",
    className: "item4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6326_51518",
    x1: -5.4178,
    y1: 85.6509,
    x2: 34.1322,
    y2: 85.6509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#EAEA15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458333,
    stopColor: "#FF855F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.692708,
    stopColor: "#FF454E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833333,
    stopColor: "#BE0EDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869792,
    stopColor: "#AD00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6326_51518",
    x1: 7.29704,
    y1: 77.9556,
    x2: 46.847,
    y2: 77.9556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#EAEA15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458333,
    stopColor: "#FF855F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.692708,
    stopColor: "#FF454E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833333,
    stopColor: "#BE0EDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869792,
    stopColor: "#AD00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6326_51518",
    x1: 24.297,
    y1: 62.9556,
    x2: 63.847,
    y2: 62.9556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#EAEA15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458333,
    stopColor: "#FF855F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.692708,
    stopColor: "#FF454E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833333,
    stopColor: "#BE0EDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869792,
    stopColor: "#AD00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6326_51518",
    x1: 43.297,
    y1: 25.9556,
    x2: 82.847,
    y2: 25.9556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#EAEA15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458333,
    stopColor: "#FF855F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.692708,
    stopColor: "#FF454E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833333,
    stopColor: "#BE0EDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869792,
    stopColor: "#AD00FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.1745e92d5d63142f887d5015ee9cb7a0.svg";
export { ForwardRef as ReactComponent };